import { pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";

export default defineTest("summarization_jobs", "Summarization jobs", ({ summarization, fetchErrors }) => {
  if (fetchErrors.summarization) {
    return skip(`Summarization data unavailable: ${fetchErrors.summarization}`);
  }
  const jobs = Array.isArray(summarization) ? summarization : summarization ? [summarization] : [];
  if (jobs.length === 0) {
    return fail("No summarization jobs found for this patient");
  }
  return pass(`${jobs.length} summarization job(s) found`);
});
